import { Copyright, DevelopedBy, VersionsDisplayer } from '@repo/ui';
import { useProductVersions } from 'presentation/app/hooks/use-product-versions';
import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
  const { frontVersion, apiVersion } = useProductVersions();

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={4}>
              <Copyright />
            </Col>
            <Col sm={4}>
              <VersionsDisplayer
                frontAppName="Admin"
                frontVersion={frontVersion}
                apiVersion={apiVersion}
              />
            </Col>
            <Col sm={4}>
              <div className="text-sm-end d-none d-sm-block">
                <DevelopedBy />
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
